export default "__VITE_ASSET__735987bc__"